import React, { useState, useEffect, useMemo } from 'react';
import DataGrid from '../../../../Core/Controls/Grid/index';
import { AddButton, EditButton, BreadCrumbs, formatters } from '../../../../Core/Controls';
import DialogBox from './eventDocumentsDialog';
import { useToast } from '../../../../Core/Hooks/useToast';
import DialogComp from '../../../../Core//Dialog/DialogComp';
import '../../../commonStyle.scss';
import GijgoGrid from '../../../../Core/Controls/GijgoGrid';

import { getAllEventDocs, postEventDocs } from '../../../../Core/Services/InternalUser/eventDocumentsService';

const crumbs = [
    { name: 'Home', path: '/' },
    { name: 'Events', active: true },
    { name: 'Event Documents', active: true }
];
const basecolumns = [
    { key: 'action', name: 'Action', width: '5%' },
    { key: 'eventDocName', name: 'Name' },
    {
        key: 'eventDocRequiredInDays',
        name: 'Required In Days',
        headerRenderer: formatters.ColumnHeaderAlignRight,
        formatter: formatters.ColumnTextAlignRight,
        width: '15%'
    },
    {
        key: 'eventDocChase',
        name: 'Chase',
        formatter: formatters.YesNo,
        width: '9%'
    },
    {
        key: 'eventDocLegal',
        name: 'Legal',
        formatter: formatters.YesNo,
        width: '9%'
    }
];
const EventDocuments = () => {
    const [state, setState] = useState({
        open: false,
        showLoader: true,
        selectedRowData: {}
    });
    const { showToastSuccess, showToastError } = useToast();

    const pullApiData = async () => {
        setState((state) => ({
            ...state,
            isReload: new Date()
        }));
    };
    const renderEdit = (ev, row) => {
        return (
            <div
                style={{
                    textAlign: 'center'
                }}
            >
                <EditButton
                    toolTipTitle="Edit Event Document"
                    onClick={() => {
                        setState((st) => ({
                            ...st,
                            open: true,
                            title: 'Edit Event Document',
                            selectedRowData: row,
                            isAdd: false
                        }));
                    }}
                />
            </div>
        );
    };
    const columns = useMemo(() => {
        const tempCols = [...basecolumns];
        let actionCol = tempCols.find((e) => e.key === 'action');
        if (actionCol) {
            actionCol.formatter = renderEdit;
        }
        return tempCols;
    }, []);

    const saveData = async (outData) => {
        let response = await postEventDocs({
            eventDocID: outData.eventDocID || null,
            eventDocName: outData.eventDocName,
            eventDocRequiredInDays: parseInt(outData.eventDocRequiredInDays),
            eventDocChase: outData.eventDocChase || false,
            eventDocLegal: outData.eventDocLegal || false
        });
        if (response) {
            response.success
                ? showToastSuccess(state.isAdd ? 'Event documents added successfully' : 'Event documents updated successfully')
                : showToastError(response.message || 'Something went wrong');
        } else {
            showToastError('Something went wrong');
        }
        pullApiData();
    };
    const addBtnClicked = () => {
        setState((st) => ({
            ...st,
            open: true,
            title: 'Add Event Document',
            isAdd: true,
            selectedRowData: {}
        }));
    };
    const handleClose = () => {
        setState((st) => ({
            ...st,
            open: false
        }));
    };

    const urlState = 'Eventdocs';
    return (
        <div className="screen">
            <BreadCrumbs crumbs={crumbs} />
            <GijgoGrid
                columns={columns}
                getUrl={urlState}
                dataConverter={(res) => ({
                    records: res.data.list,
                    total: res.data.total
                })}
                isReload={state.isReload}
                btnTitle="Add Event Document"
                onBtnClick={() => addBtnClicked(null)}
            />
            {state.open ? (
                <DialogComp open={state.open} onClose={handleClose} title={state.title} maxWidth="md">
                    <DialogBox data={state} onClose={handleClose} saveData={saveData} />
                </DialogComp>
            ) : null}
        </div>
    );
};

export default EventDocuments;
